// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Cone(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Cone" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M14 3H10L9 8H15L14 3Z", fill: "currentColor" }),
            React.createElement("path", { d: "M8.4 11L8.8 9H15.2L15.6 11H8.4Z", fill: "currentColor" }),
            React.createElement("path", { d: "M8.2 12L7 18H5C4.44772 18 4 18.4477 4 19V21H20V19C20 18.4477 19.5523 18 19 18H17L15.8 12H8.2Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Cone.js.map